module.exports = __webpack_public_path__ + "assets/media/yes-about.6fd16d1f.svg";